// flights
import flight1 from "../Images/Bookings/flight1.jpg";
import flight2 from "../Images/Bookings/flight2.jpg";
import flight3 from "../Images/Bookings/flight3.jpg";
import flight4 from "../Images/Bookings/flight4.jpg";
import flight5 from "../Images/Bookings/flight5.jpg";
import flight6 from "../Images/Bookings/flight6.jpg";

const flights = [
  {
    src: flight1,
    cardtitle: "Make My Trip",
    cardtext: "Get best deals on flights from Make My Trip",
    link: "https://www.makemytrip.com/flights/mysore-flight-tickets.html",
  },
  {
    src: flight2,
    cardtitle: "Flipkart",
    cardtext: "Get best deals on flights from Flipkart",
    link:
      "https://www.flipkart.com/travel/flights?otracker=nmenu_Flights&gclsrc=aw.ds&?semcmpid=sem_5434336052_flights_generic_goog&gclid=Cj0KCQiAzsz-BRCCARIsANotFgMyU6OkwlqVcAf5R3IMqsPlF4BuRbtrYviGvk-6lyBOiCo1lP_ST28aAl7gEALw_wcB",
  },
  {
    src: flight3,
    cardtitle: "Skyscanner",
    cardtext: "Get best deals on flights from Skyscanner",
    link:
      "https://www.skyscanner.co.in/flights-to/myq/cheap-flights-to-mysore-airport.html",
  },
  {
    src: flight4,
    cardtitle: "Goibibo",
    cardtext: "Get best deals on flights from Goibibo",
    link: "https://www.goibibo.com/flights/hyderabad-to-mysore-flights/",
  },
  {
    src: flight5,
    cardtitle: "Travolook",
    cardtext: "Get best deals on flights from Travolook",
    link:
      "https://www.travolook.in/?gclid=Cj0KCQiAzsz-BRCCARIsANotFgN4Q6z4WGcF7jI6EV8AQ06R0hfOPdnIEFzTwxsOJRmS_6lbGsP5GTwaAn6nEALw_wcB",
  },
  {
    src: flight6,
    cardtitle: "Yatra",
    cardtext: "Get best deals on flights from Yatra",
    link: "https://www.yatra.com/domestic-flights/flights-to-mysore.html",
  },
];

export default flights;
